import {AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {Observable, ReplaySubject} from "rxjs";
import {AffiliateCode} from "../../../shared/interface/affiliateCode";
import {MatPaginator} from "@angular/material/paginator";
import {MatDialog} from "@angular/material/dialog";
import {MatSnackBar} from "@angular/material/snack-bar";
import {AuthService} from "../../../shared/services/auth.service";
import {MatTableDataSource} from "@angular/material/table";
import {UserPermissions} from "../../../shared/interface/user-permissions";
import {takeUntil} from "rxjs/operators";
import {ConfirmDialogComponent} from "../../../shared/components/confirm-dialog/confirm-dialog.component";
import {HttpErrorResponse} from "@angular/common/http";
import {AffiliateCodeService} from "../../../shared/services/affiliate-code.service";
import {AFFILIATE_CODE_STATUS_ACTIVE, AFFILIATE_CODE_STATUS_INACTIVE} from "../../../shared/services/dict.service";
import {AffiliateLinkService} from "../../../shared/services/affiliate-link.service";

@Component({
  selector: 'app-affiliate-code-list',
  templateUrl: './affiliate-code-list.component.html',
  styleUrls: ['./affiliate-code-list.component.scss']
})
export class AffiliateCodeListComponent implements OnInit, OnDestroy, AfterViewInit {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  @Input() affiliateCodes: Observable<AffiliateCode[]>;
  @Input() excludeColumns: string[] = null;
  @Output() loadAffiliate: EventEmitter<boolean> = new EventEmitter<boolean>();
  @ViewChild(MatPaginator) paginator: MatPaginator;

  readonly AFFILIATE_CODE_STATUS_ACTIVE = AFFILIATE_CODE_STATUS_ACTIVE;
  readonly AFFILIATE_CODE_STATUS_INACTIVE = AFFILIATE_CODE_STATUS_INACTIVE;

  dataSource: MatTableDataSource<AffiliateCode>;
  userPermissions: ReplaySubject<UserPermissions>;
  displayedColumns: string[] = ['insuranceCompany' , 'name', 'affiliateLink', 'code', 'ofwca', 'partner', 'contactDetails', 'status', 'concludeDate', 'action'];

  constructor(
    private auth: AuthService,
    private dialog: MatDialog,
    private affiliateCodeService: AffiliateCodeService,
    private affiliateLinkService: AffiliateLinkService,
    private snack: MatSnackBar,
  ) {
    this.userPermissions = auth.getUserPermissions();
    this.dataSource = new MatTableDataSource<AffiliateCode>([]);
  }

  ngOnInit(): void {
    this.affiliateCodes
      .pipe(
        takeUntil(this.destroyed$)
      ).subscribe((affiliateCodes: AffiliateCode[]) => this.dataSource.data = affiliateCodes);

    this.displayedColumns = this.displayedColumns.filter((e: string) => !this.excludeColumns || this.excludeColumns.indexOf(e) === -1);
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
  }
  delete(affiliateCode: AffiliateCode): void{
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: {text: 'Czy na pewno chcesz zablokować kod? Po zablokowaniu kod nie będzie uprawniał do zniżek.'},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.affiliateCodeService.delete(affiliateCode.uuid)
          .subscribe(() => {
            this.snack.open('Pomyślnie zablokowano kod', '', {duration: 2000});
            this.loadAffiliate.emit();
          }, (error: HttpErrorResponse) => {
            this.snack.open('Podczas dezaktywacja kod wystąpił błąd', error.status.toString(), {
              duration: 2000,
            });

            if (error.status === 400) {
              this.snack.open(error.error.error.text, null, {duration: 4000});
            }
          });
      }
    });
  }

  linkDelete(affiliateLink: any): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: { text: 'Czy na pewno chcesz usunąć link afiliacyjny?' },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.affiliateLinkService.delete(affiliateLink.uuid)
          .subscribe(() => {
            this.snack.open('Pomyślnie usunięto link afiliacyjny', '', { duration: 2000 });
            this.loadAffiliate.emit();
          }, (error: HttpErrorResponse) => {
            this.snack.open('Podczas usuwania linku wystąpił błąd', error.status.toString(), {
              duration: 2000,
            });

            if (error.status === 400) {
              this.snack.open(error.error.error.text, null, { duration: 4000 });
            }
          });
      }
    });
  }

  restore(affiliateCode: AffiliateCode): void{
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: {text: 'Czy na pewno chcesz odblokować kod?'},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.affiliateCodeService.restore(affiliateCode.uuid)
          .subscribe(() => {
            this.snack.open('Pomyślnie odblokowano kod', '', {duration: 2000});
            this.loadAffiliate.emit();
          }, (error: HttpErrorResponse) => {
            this.snack.open('Podczas odblokowywana kodu wystąpił błąd', error.status.toString(), {
              duration: 2000,
            });

            if (error.status === 400) {
              this.snack.open(error.error.error.text, null, {duration: 4000});
            }
          });
      }
    });
  }
}
